import { useQuery, UseQueryOptions } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { ArticleClient } from 'api/clients/ArticleClient'
import { layersKeys } from './layersKeys'
import { useArticlePassword } from 'hooks/useArticlePassword'
import { Layer } from 'types'
import { QueryKey } from 'react-query/types/core/types'
import { isUndefined } from 'lodash'

interface Props {
  articleKey: string
  staleTime?: number
}

export const useLayers = (
  { articleKey, staleTime = 1000 * 60 * 5 }: Props,
  options?: UseQueryOptions<{ layers: Layer[] }>,
) => {
  const password = useArticlePassword(articleKey)
  const key = layersKeys.list(articleKey, { password }) as QueryKey
  return useQuery(
    key,
    async () => {
      const res = await ArticleClient.getLayers(articleKey, password)

      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }
      return res.data
    },
    {
      staleTime,
      cacheTime: staleTime * 1.5,
      refetchOnWindowFocus: false,
      enabled: (isUndefined(options?.enabled) || options?.enabled) && !!articleKey,
      ...options,
    },
  )
}
